/**
 * Monaco language for Control Designer ScopeScript.
 * JavaScript-like highlighting without the TypeScript worker, so completion
 * is driven solely by our ScopeScript provider.
 */

let scopeScriptLanguageRegistered = false;

export const CONTROL_SCOPE_SCRIPT_LANGUAGE_ID = 'control-scopescript';

export function scopeScriptLanguageConfiguration() {
    return {
        comments: {
            lineComment: '//',
            blockComment: ['/*', '*/'],
        },
        brackets: [
            ['{', '}'],
            ['[', ']'],
            ['(', ')'],
        ],
        autoClosingPairs: [
            { open: '{', close: '}' },
            { open: '[', close: ']' },
            { open: '(', close: ')' },
            { open: '"', close: '"', notIn: ['string'] },
            { open: "'", close: "'", notIn: ['string'] },
        ],
        surroundingPairs: [
            { open: '{', close: '}' },
            { open: '[', close: ']' },
            { open: '(', close: ')' },
            { open: '"', close: '"' },
            { open: "'", close: "'" },
        ],
    };
}

export function buildScopeScriptMonarch() {
    return {
        defaultToken: 'identifier',
        keywords: [
            'Control', 'Params', 'api', 'controlModel', 'util', 'async', 'await', 'break', 'case', 'catch', 'class', 'const', 'continue',
            'debugger', 'default', 'delete', 'do', 'else', 'export', 'extends', 'false', 'finally',
            'for', 'function', 'if', 'import', 'in', 'instanceof', 'let', 'new', 'null', 'return',
            'super', 'switch', 'this', 'throw', 'true', 'try', 'typeof', 'undefined', 'var', 'void',
            'while', 'with', 'yield', 'of',
        ],
        tokenizer: {
            root: [
                [/\/\*/, 'comment', '@comment'],
                [/\/\/.*$/, 'comment'],
                [/"/, 'string', '@string_double'],
                [/'/, 'string', '@string_single'],
                [/0[xX][0-9a-fA-F]+\b/, 'number.hex'],
                [/\d*\.\d+([eE][\-+]?\d+)?\b/, 'number.float'],
                [/\d+\b/, 'number'],
                [/[{}()\[\]]/, 'delimiter.bracket'],
                [/[;,.]/, 'delimiter'],
                [
                    /[A-Za-z_$][\w$]*/,
                    {
                        cases: {
                            '@keywords': 'keyword',
                            '@default': 'identifier',
                        },
                    },
                ],
                [/[+\-*/%&|^!~<>=?:]+/, 'operator'],
            ],
            comment: [
                [/[^\/*]+/, 'comment'],
                [/\*\//, 'comment', '@pop'],
                [/[\/*]/, 'comment'],
            ],
            string_double: [
                [/[^\\"]+/, 'string'],
                [/\\./, 'string.escape'],
                [/"/, 'string', '@pop'],
            ],
            string_single: [
                [/[^\\']+/, 'string'],
                [/\\./, 'string.escape'],
                [/'/, 'string', '@pop'],
            ],
        },
    };
}

/**
 * @param {import('monaco-editor')} monaco
 */
export function ensureControlScopeScriptLanguage(monaco) {
    if (scopeScriptLanguageRegistered)
        return;

    monaco.languages.register({ id: CONTROL_SCOPE_SCRIPT_LANGUAGE_ID });
    monaco.languages.setLanguageConfiguration(
        CONTROL_SCOPE_SCRIPT_LANGUAGE_ID,
        scopeScriptLanguageConfiguration(),
    );
    monaco.languages.setMonarchTokensProvider(
        CONTROL_SCOPE_SCRIPT_LANGUAGE_ID,
        buildScopeScriptMonarch(),
    );
    scopeScriptLanguageRegistered = true;
}
